<div class="structure-box pt-md">
  <!--  搜索框-->
  <div>
    <nz-input-group class="search-input" [nzPrefix]="searchIcon" [nzSuffix]="suffixIconSearch">
      <input nz-input class="selfRadius" placeholder="搜索部门/人员名称" [(ngModel)]="searchKey" />
    </nz-input-group>
    <ng-template #searchIcon>
      <i nz-icon nzIconfont="icon_search" class="text-gray1" style="font-size: 14px"></i>
    </ng-template>
    <ng-template #suffixIconSearch>
      <i nz-icon nzIconfont="icon_shibai-xianxing" class="pointer text-gray1" *ngIf="searchKey != ''" (click)="searchKey = ''"></i>
    </ng-template>
  </div>
  <!--  搜索框End-->
  <!--  类型tab-->
  <div class="type-tab-box mt-md" [ngClass]="{ hide: searchStatus }">
    <radio-button
      [data]="typeOptions"
      [(check)]="checkType"
      (checkChange)="checkTypeChange($event)"
      [itemStyle]="{ 'margin-bottom': 0, width: '60px', padding: 0 }"
      [checkPoint]="false"
    ></radio-button>
  </div>
  <!--  类型tab End-->
  <div class="structure-tree mt-sm" [ngClass]="{ hide: searchStatus }">
    <nz-tree
      [nzSearchValue]="searchKey"
      [nzData]="showStructure"
      (nzClick)="checkStructure($event)"
      [nzTreeTemplate]="treeTpl"
      [nzExpandedKeys]="defaultExpandedKeys"
      [nzCheckStrictly]="true"
      [nzExpandAll]="true"
      [nzVirtualHeight]="height - 104 + 'px'"
      style="background: var(--gray-bg)"
    >
      <ng-template #treeTpl let-node>
        <div class="flexRow text-nowrap text-truncate">
          <i nz-icon nzIconfont="icon_jiagou" *ngIf="node.level == 0" class="structure-icon mr-sm"></i>
          <i
            nz-icon
            nzIconfont="icon_pianqu"
            *ngIf="node.origin['organ_type'] == 1 && node.origin['organ_type_extra'] == 2"
            class="structure-icon mr-sm"
          ></i>
          <i
            nz-icon
            nzIconfont="icon_arrive"
            *ngIf="node.origin['organ_type'] == 1 && node.origin['organ_type_extra'] == 3"
            class="structure-icon mr-sm"
          ></i>
          <i
            nz-icon
            nzIconfont="icon_zu"
            *ngIf="(node.origin['organ_type_extra'] == 0 || node.origin['organ_type_extra'] == 4) && node.level > 0"
            class="structure-icon mr-sm"
          ></i>
          <i nz-icon nzIconfont="icon_user" *ngIf="node.origin['employee_id'] > 6" class="structure-icon mr-sm"></i>
          <div class="mr-sm">{{ node.title }}</div>
          <!--          <div class='text-gray1' [ngClass]="{'d-none':node.origin['manage_name']==''}">-->
          <!--            ({{ node.origin['manage_name']  }})-->
          <!--          </div>-->
        </div>
      </ng-template>
    </nz-tree>
  </div>
</div>
